import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { JwtService } from '@app/core/auth';
import { map, catchError, of } from 'rxjs';

function isTokenValidLocally(jwtService: JwtService): boolean {
  const token = jwtService.getToken();
  if (!token) return false;

  const decodedToken = jwtService.decodeToken();
  if (!decodedToken) return false;

  return decodedToken.exp >= Math.floor(Date.now() / 1000);
}

export const authGuard: CanActivateFn = () => {
  const jwtService = inject(JwtService);

  if (!isTokenValidLocally(jwtService)) {
    return jwtService.checkTokenAndRedirect().pipe(
      map(isValid => {
        if (!isValid) {
          jwtService.redirectLoginPage();
          return false;
        }
        return true;
      }),
      catchError(() => {
        jwtService.removeToken();
        jwtService.redirectLoginPage();
        return of(false);
      })
    );
  }

  return of(true);
};
